import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { DatePickerModule } from 'primeng/datepicker';
import { InputIconModule } from 'primeng/inputicon';
import { SelectModule } from 'primeng/select';
import { Popover } from 'primeng/popover';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { DrawerModule } from 'primeng/drawer';
import { CheckboxModule } from 'primeng/checkbox';
import { MessageService } from 'primeng/api';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { TooltipModule } from 'primeng/tooltip';


interface City {
  name: string;
  code: string;
}

@Component({
  selector: 'app-tool-bar',
  imports: [IconFieldModule, CommonModule, ButtonModule,
    FormsModule, DatePickerModule, InputIconModule, SelectModule,
    Popover, InputGroupAddonModule, InputTextModule, MenuModule, DrawerModule, CheckboxModule, SharedModule, TooltipModule
  ],
  templateUrl: './tool-bar.component.html',
  styleUrl: './tool-bar.component.scss'
})
export class ToolBarComponent {

  @Input() title: string = '';
  @Input() iconName: string = '';
  @Input() isSearch: boolean = false;
  @Input() isDateFilter: boolean = false;
  @Input() isImport: boolean = false;
  @Input() isExport: boolean = false;
  @Input() isAdd: boolean = false;
  @Input() selectedProducts: any[] = [];
  @Input() isBulkAction: boolean = false;
  @Input() isFilter: boolean = false;
  @Input() isRefresh: boolean = false;
  @Input() tableView: boolean = false;
  @Input() isFilterDrawer: boolean = false;
  @Input() isFindDuplicate: boolean = false;
  @Input() duplicateCount: number = 0;
  @Input() isDownloadForm: boolean = false;
  @Output() handleBulkAction = new EventEmitter<any>();
  @Output() handleAdd = new EventEmitter<any>();
  @Output() handleFindDuplicate = new EventEmitter<any>();
  @Output() handleDownloadForm = new EventEmitter<any>();
  @Input() bulkActionItems: any[] = [];
  @Input() filterOptions: any[] = [];
  @Input() exportItems: any[] = [];
  @Input() filtersOptions: any[] = [];
  @Input() showToggleIcon: boolean = false;
  @Output() bulkUpload = new EventEmitter<any>();
  @Output() search = new EventEmitter<any>();
  @Output() dateFilter = new EventEmitter<any>();
  @Output() handleRefresh = new EventEmitter<any>();
  @Output("ExportData") ExportData: EventEmitter<any> = new EventEmitter();
  @Output() applyFilter = new EventEmitter<any>();
  @Output() toggleFilter = new EventEmitter<any>();
  @Output() clearFilter = new EventEmitter<any>();

  @Output() resetDateFilter = new EventEmitter<any>();
  @Output() handleToggleView = new EventEmitter<any>();


  cities: City[] | undefined;

  selectedCity: City | undefined;

  showFilterDrawer: boolean = false;
  selectAllChecked: boolean = false;
  isApplyingFilter: boolean = false;


  rangeDates: Date[] | undefined;

  selectedFilterAttribute = '';
  searchInputValue: string = '';
  searchDropdownValue: string | null = '';

  private searchSubject = new Subject<{value: string | null, attr: string}>();

  get currentFilterOption(): any {
    return this.filtersOptions.find(f => f.value === this.selectedFilterAttribute);
  }

  get isDropdownFilter(): boolean {
    return this.currentFilterOption?.type === 'dropdown';
  }

  constructor(
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.rangeDates = [new Date(), new Date()];
    this.cities = [
      { name: 'New York', code: 'NY' },
      { name: 'Rome', code: 'RM' },
      { name: 'London', code: 'LDN' },
      { name: 'Istanbul', code: 'IST' },
      { name: 'Paris', code: 'PRS' }
    ];

    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged((a, b) => a.value === b.value && a.attr === b.attr)
    ).subscribe(({value, attr}) => {
      this.search.emit({
        value,
        selectedFilterAttribute: attr
      });
    });
  }

  handleSelectedBulkAction(event: any) {
    this.handleBulkAction.emit(event);
  }

  checkedData: any[] = [];

  storeCheckedData() {
    this.checkedData = this.filterOptions.map(group => ({
      label: group.label,
      items: group.items.filter((item: any) => item.checked)
    }));
    console.log(this.checkedData);
  }

  clearFilters() {
    this.filterOptions.forEach(group => {
      group.items.forEach((item: any) => item.checked = false);
    });
    this.clearFilter.emit();
    this.showFilterDrawer = false;
  }

  handleApplyFilter() {
    this.checkedData = this.filterOptions.map(group => ({
      label: group.label,
      items: group.items.filter((item: any) => item.checked)
    }));
    this.showFilterDrawer = false;
    this.applyFilter.emit(this.checkedData);
  }
    



  // Toggle individual checkboxes
  toggleSelection(index: number) {
    this.exportItems[index].checked = !this.exportItems[index].checked;
  }

  // Toggle all checkboxes
  toggleSelectAll() {
    // this.selectAllChecked = !this.selectAllChecked;
    console.log('Select All:', this.selectAllChecked);
    this.exportItems.forEach(item => (item.checked = this.selectAllChecked));
  }

  // Save Selected Values
  saveSelection() {
    const selectedValues = this.exportItems
      .filter(item => item.checked)
      .map(item => item);
    console.log('Selected values:', selectedValues);

    if (selectedValues.length == 0) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select column' });
      return;
    }
    this.selectAllChecked = false;
    this.ExportData.emit(selectedValues);

  }

  handleAddAction() {
    this.handleAdd.emit();
  }

  handleFindDuplicateAction() {
    this.handleFindDuplicate.emit();
  }

  handleOpenBulkAdd() {
    this.bulkUpload.emit();
  }


  onSearchChange(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    this.searchInputValue = inputValue;
    this.searchSubject.next({ value: inputValue, attr: this.selectedFilterAttribute });
  }

  onFilterAttributeChange() {
    this.searchInputValue = '';
    this.searchDropdownValue = ''; // '' = no selection; null = "Not Assigned" chosen
    // do NOT emit — just reset local state, no API call on attribute change
  }

  onSearchDropdownChange(value: string | null) {
    this.searchDropdownValue = value;
    this.searchSubject.next({ value, attr: this.selectedFilterAttribute });
  }

  handleResetSearchFilter() {
    this.selectedFilterAttribute = '';
    this.searchInputValue = '';
    this.searchDropdownValue = '';
    this.searchSubject.next({ value: '', attr: '' });
  }

  handleRefreshDateFilter() {
    this.rangeDates = [new Date(), new Date()];
    this.dateFilter.emit({
      startDate: null,
      endDate: null
    });
  }

  onDateChange(event: any) {

    console.log("rangeDates", this.rangeDates);
    let startDate;
    let endDate;

    if(this.rangeDates && this.rangeDates[0] != undefined){
      startDate = this.formatDate(this.rangeDates[0]);
    }

    if(this.rangeDates && this.rangeDates[1] != undefined){
      endDate = this.formatDate(this.rangeDates[1]);
    }
    
    if(startDate && endDate){
      console.log('Start Date:', startDate);
      console.log('End Date:', endDate);
      this.dateFilter.emit({
        startDate,
        endDate
      });
    }

  }
  formatDate = (dateString: any): string => {
    console.log('Date:', dateString);
    const date = new Date(dateString);
    const yy = date.getFullYear().toString(); // Get last 2 digits of year
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
    const dd = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    return `${yy}-${mm}-${dd}`;
  };


  refreshData() {
    this.handleRefresh.emit();
  }

  handleResetDateFilter() {
    this.resetDateFilter.emit();
    this.rangeDates = [new Date(), new Date()];
  }


  toggleView() {
    this.handleToggleView.emit();
  }

  handleDownloadFormAction() {
    this.handleDownloadForm.emit();
  }

  setDateRange(preset: string) {
    const today = new Date();
    let startDate: Date;
    let endDate: Date;

    switch (preset) {
      case 'today':
        startDate = new Date(today);
        endDate = new Date(today);
        break;

      case 'yesterday':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 1);
        endDate = new Date(startDate);
        break;

      case 'thisWeek':
        // Start from Monday of current week
        startDate = new Date(today);
        const dayOfWeek = startDate.getDay();
        const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust if Sunday (0)
        startDate.setDate(today.getDate() + diff);
        endDate = new Date(today);
        break;

      case 'lastWeek':
        // Last Monday to Last Sunday
        const lastWeekEnd = new Date(today);
        const currentDay = lastWeekEnd.getDay();
        const daysToLastSunday = currentDay === 0 ? 0 : currentDay;
        lastWeekEnd.setDate(today.getDate() - daysToLastSunday);
        
        endDate = new Date(lastWeekEnd);
        startDate = new Date(lastWeekEnd);
        startDate.setDate(lastWeekEnd.getDate() - 6);
        break;

      case 'thisYear':
        startDate = new Date(today.getFullYear(), 0, 1); // January 1st
        endDate = new Date(today);
        break;

      case 'lastYear':
        startDate = new Date(today.getFullYear() - 1, 0, 1); // January 1st of last year
        endDate = new Date(today.getFullYear() - 1, 11, 31); // December 31st of last year
        break;

      default:
        return;
    }

    this.rangeDates = [startDate, endDate];
    this.dateFilter.emit({
      startDate: this.formatDate(startDate),
      endDate: this.formatDate(endDate)
    });
  }

}
